<div class="gpd-role-select" *ngIf="mode === 'select'">
  <dx-select-box
    class="gpd-input"
    [dataSource]="roles"
    displayExpr="name"
    valueExpr="name"
    itemTemplate="roleItemTemplate"
    [dropDownOptions]="{ wrapperAttr: { class: 'gpd-role-select-popup' } }"
    [value]="value"
    (onValueChanged)="onValueChanged($event)"
    (onInitialized)="onSelectBoxInitialized($event)"
    [searchEnabled]="true"
    searchExpr="name"
    [showClearButton]="true"
    i18n-placeholder="@@rolePlaceholder"
    placeholder="Select a role"
  >
    <div *dxTemplate="let role of 'roleItemTemplate'" class="gpd-role-select__item">
      <span class="gpd-role-select__item-text">{{ role.name }}</span>
      <button
        type="button"
        class="gpd-role-select__item-edit"
        i18n-title="@@editRole"
        title="Edit role"
        (mousedown)="$event.stopPropagation()"
        (click)="startEditing(role, $event)"
      >
        <app-svg-icon icon="edit" [size]="14"></app-svg-icon>
      </button>
    </div>

    <dx-validator *ngIf="required">
      <dxi-validation-rule
        type="required"
        i18n-message="@@roleRequired"
        message="Please define a role"
      ></dxi-validation-rule>
    </dx-validator>
  </dx-select-box>

  <app-gpd-button
    type="text"
    icon="add"
    i18n-text="@@addNewRole"
    text="Add new role"
    (onClick)="startAddingNew()"
  ></app-gpd-button>
</div>

<div class="gpd-role-select gpd-role-select--new" *ngIf="mode !== 'select'">
  <dx-text-box
    class="gpd-input"
    [(value)]="inputText"
    [width]="'100%'"
    i18n-placeholder="@@newRolePlaceholder"
    placeholder="Enter new role"
    (onEnterKey)="handleEnterKey()"
    (onFocusOut)="finishEditing()"
  ></dx-text-box>
</div>
